import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoordinatesService {

  private pointDrawnSubject = new Subject<[number, number]>();
  pointDrawn$ = this.pointDrawnSubject.asObservable();
  private historyRecordsSubject = new Subject<any>();
  historyRecords$ = this.historyRecordsSubject.asObservable();
  private historyCityRecordsSubject = new Subject<any>();
  historyCityRecords$ = this.historyCityRecordsSubject.asObservable();
  private savedRecordSubject = new Subject<any>();
  savedRecordUpdated$ = this.savedRecordSubject.asObservable();
  private sharedLocationCitySubject = new Subject<any>();
  sharedLocationCityRecords$ = this.sharedLocationCitySubject.asObservable();
  private contentRecordsSubject = new Subject<any>();
  contentRecordsUpdated$ = this.contentRecordsSubject.asObservable();
  private contentRecordsCitySubject = new Subject<any>();
  contentRecordsUpdatedCity$ = this.contentRecordsCitySubject.asObservable();
  private contentRecordsCityMapCodeSubject = new Subject<any>();
  contentRecordsUpdatedCityByMapCode$ = this.contentRecordsCityMapCodeSubject.asObservable();
  private playerOuterCoordinatesSubject = new BehaviorSubject<any>('');
  playerOuterCoordinates$ = this.playerOuterCoordinatesSubject.asObservable();
  private atCityBoundarySubject = new BehaviorSubject<boolean>(false);
  atCityBoundary$ = this.atCityBoundarySubject.asObservable();

  setAtCityBoundary(value: boolean) {
    this.atCityBoundarySubject.next(value);
  }
  constructor() { }


  setNewCoordinates(value) {
    this.pointDrawnSubject.next(value)
  }
  setNewHistoryRecords(records) {
    this.historyRecordsSubject.next(records);
  }

  setNewCityHistoryRecords(records) {
    this.historyCityRecordsSubject.next(records);
  }
  setNewSavedRecords(records) {
    this.savedRecordSubject.next(records);
  }

  setNewPlayerOuterCoordinates(records) {
    this.playerOuterCoordinatesSubject.next(records);
  }

  setNewContentRecords(records) {
    this.contentRecordsSubject.next(records);
  }

  setNewCityContentRecords(records) {
    this.contentRecordsCitySubject.next(records);
  }

  setCityContentRecordsByMapCodeCityCode(records) {
    this.contentRecordsCityMapCodeSubject.next(records);
  }

  setNewSharedLocationCity(records) {
    this.sharedLocationCitySubject.next(records)
  }
}
